import { IntlFormatters } from 'react-intl';

import { LoyaltyUser } from '../types';

import { getNextQuarterDate, getTomorrowDate } from './helpers';

export const walmartOfferIds = [
  '8f059309-e9f2-4c3f-92a6-9dea0a5fce06', // Quarterly free Whopper
  'a48ac94b-298b-49ae-a1fe-ef576b644712', // Daily 25% off
];

enum WalmartEngineOffers {
  QUARTERLY_FREE_WHOPPER = '4e789a40-3de8-4cc5-b06e-8b0bc77e9579',
  DAILY_TWENTY_FIVE_PERCENT_OFF = '1659a35d-5933-410c-9718-736c3b78c122',
}

export const walmartOfferEngineIds: string[] = [
  WalmartEngineOffers.QUARTERLY_FREE_WHOPPER,
  WalmartEngineOffers.DAILY_TWENTY_FIVE_PERCENT_OFF,
];

export const isWalmartOffer = (offer: Record<string, any>): boolean => {
  return walmartOfferIds.includes(offer.id || offer._id);
};

export const isWalmartOfferEngineId = (loyaltyEngineId: WalmartEngineOffers): boolean => {
  return walmartOfferEngineIds.includes(loyaltyEngineId);
};

export const isActiveWalmartUser = (loyaltyUser: LoyaltyUser): boolean => {
  return (
    loyaltyUser?.partnerUserData?.some(
      data => data.partner === 'WALMART' && data.status === 'ACTIVE'
    ) || false
  );
};

/**
 * Push Walmart Offers to the top of the list
 */
export const pushWalmartOffersToTop = (a: Record<string, any>, b: Record<string, any>) => {
  if (isWalmartOffer(a) && !isWalmartOffer(b)) {
    return -1;
  } else if (!isWalmartOffer(a) && isWalmartOffer(b)) {
    return 1;
  }
  return 0;
};

export const getMissingWalmartOfferEngineIds = (offerIds: string[]): string[] => {
  const includedWalmartOfferIds = offerIds.filter(id => walmartOfferEngineIds.includes(id));
  if (includedWalmartOfferIds.length < 2) {
    return walmartOfferEngineIds.filter(id => !includedWalmartOfferIds.includes(id));
  }
  return [];
};

export const getWalmartOfferUnavailableMessage = (
  loyaltyEngineId: string,
  formatters: IntlFormatters
): string => {
  const date =
    loyaltyEngineId === WalmartEngineOffers.QUARTERLY_FREE_WHOPPER
      ? getNextQuarterDate()
      : getTomorrowDate();
  const message = formatters.formatMessage(
    { id: 'availableAgainOn' },
    {
      date: formatters.formatDate(date),
    }
  );
  return message;
};
